// extracted by mini-css-extract-plugin
export default {"wrap":"xq-z","logoContainer":"yq-z","brandImg":"zq-z","logoImg":"Aq-z","logoButton":"Bq-z"};